webpackJsonp([72499185232889],{

/***/ 456:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/brand-success-only-with-the-right-consumer-data/"},"frontmatter":{"title":"Brand Success: Only with the right consumer data"}}}]}},"pathContext":{"tag":"consumer"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-consumer-76c1dfa355da81712c03.js